<template>
    <Loading :loading="loading" :text="$t('receive_mail_for_password_reset') + '...'">
        <form @submit.prevent="forgotPassword()">
            <Input type="text" name="email" :formComponentId="this.$.uid" :required="true" :label="$t('mail')" v-model:value="user.email" autocomplete="email" class="my-4">
            </Input>
            <FormButton type="submit" class="my-6" styling="primary flex items-center gap-3" :value="$t('reset_password')" :disabled="loading">
                <FontAwesomeIcon
                    v-show="loading"
                    :icon="['fas', 'circle-notch']"
                    class="animate-spin text-white transition-all ease-in-out duration-300 w-0"
                    :class="loading ? 'w-10' : ''"
                >
                </FontAwesomeIcon>
            </FormButton>
        </form>
    </Loading>
</template>

<script>
export default {
    props: {
        showLinks: Boolean
    },

    data: () => ({
        user: {},
        loading: false
    }),

    methods: {
        forgotPassword() {
            this.$store.commit('error/unsetByComponentId', this.$.uid);
            this.user.config = { componentId: this.$.uid };
            this.$store
                .dispatch('user/forgot_password', this.user)
                .then(() => {
                    setTimeout(() => {
                        this.loading = false;
                        this.user = {};
                    }, 2000);
                })
                .catch(() => {
                    setTimeout(() => {
                        this.loading = false;
                    }, 2000);
                });
        }
    },
    mounted() {
        if (this.$route.query.email) {
            this.user.email = this.$route.query.email;
        }
    }
};
</script>
